import React from 'react';
import styled from 'styled-components';

import VerticalImageNContent from '@/components/ContextPrinter/VerticalImageNContent';
import PlannerPart from '@/containers/ina/modal/PlannerPartAtAnswer';
import StutusPart from '@/containers/ina/modal/StatusPartAtAnswer';
import { FontStyle } from '@/utils/StyleUtil';
import { CONFIRMATION_EFFECTIVEDATE_GUIDE_TEXT, IAnswer, QNA_STATUS } from '@/models/ina';
import DividerDefault from '@/components/Divider/Default';
import ConfirmationEffectiveDatePart from './ConfirmationEffectiveDatePart';
import DotExplanation from '@/components/ContextPrinter/DotExplanation';
import Seperator from '@/components/Spacing/Seperator';
import jwt_decode from 'jwt-decode';
import { IJwt } from '@/models';

interface IProps {
    answerData: IAnswer[];
    clientId: number;
    questionStatus: number;
}

const RenderAnswer = ({ answerData, clientId, questionStatus }: IProps) => {
    //const accessToken = localStorage.getItem('accessToken');
    // const decodedClientId = accessToken ? (jwt_decode(accessToken!) as IJwt).clientId : -1;
    const answerDataFiltered = answerData.filter((item: IAnswer) => {
        if (item.plannerSummary && item.plannerSummary.associationNumber) {
            return true;
        } else if (item.plannerSummary === null) {
            return true;
        } else {
            return false;
        }
    });

    const renderAnswer = (item: IAnswer, index: number) => {
        return (
            <AnswerContainer key={`${item.content}_${index}`}>
                <PlannerPart plannerInfo={item.plannerSummary} />
                <AnswerText>{item.content}</AnswerText>
                <StutusPart item={item} />
                {item.plannerSummary &&
                    item.plannerSummary.associationNumber &&
                    item.advConfirmationCode &&
                    item.advConfirmationEffectiveDateStartedAt &&
                    item.advConfirmationEffectiveDateExpiredAt && (
                        <>
                            <Divider thickness={1} color="#F1F1F1" />
                            <ConfirmationEffectiveDatePart
                                associationNumber={item.plannerSummary.associationNumber}
                                advConfirmationCode={item.advConfirmationCode}
                                advConfirmationEffectiveDateStartedAt={item.advConfirmationEffectiveDateStartedAt}
                                advConfirmationEffectiveDateExpiredAt={item.advConfirmationEffectiveDateExpiredAt}
                            />
                        </>
                    )}
            </AnswerContainer>
        );
    };

    const renderBlindedAnswer = () => {
        return (
            <BlindedAnswerContainer>
                <VerticalImageNContent
                    svg="round-exclamation-mark-circle"
                    width={24}
                    height={24}
                    stroke="#c8c8c8"
                    strokeWidth={1.6}
                    content="블라인드 처리된 글입니다"
                    fontStyle={{ color: '#acacac' }}
                />
            </BlindedAnswerContainer>
        );
    };

    const renderNoAnswer = () => {
        return (
            <NoAnswerContainer>
                <VerticalImageNContent
                    image="/img/ina/no_answer@3x.png"
                    imageWidth={92}
                    imageHeight={92}
                    content={`아직 등록된 답변이 없어요\n조금만 기다려주세요!`}
                    fontStyle={{ color: '#989898' }}
                />
            </NoAnswerContainer>
        );
    };

    // 미답변 완료
    const renderNoAnswerComplete = () => {
        return (
            <NoAnswerContainer>
                <VerticalImageNContent
                    image="/img/ina/no_answer_g@3x.png"
                    imageWidth={92}
                    imageHeight={92}
                    content={`답변등록 기간이 만료되었습니다`}
                    fontStyle={{ color: '#989898' }}
                />
            </NoAnswerContainer>
        );
    };

    if (answerDataFiltered.length > 0) {
        return (
            <div>
                <AnswerCount>{`총 ${answerDataFiltered.length}개의 답변이 있습니다.`}</AnswerCount>
                {answerDataFiltered.map((item: IAnswer, index: number) => (
                    <div key={`${item.content}_${index}`}>
                        {item.isBlind ? renderBlindedAnswer() : renderAnswer(item, index)}
                        <Seperator height={20} />
                    </div>
                ))}
            </div>
        );
    } else if (questionStatus === QNA_STATUS.UNANSWERED) {
        return renderNoAnswerComplete();
    } else {
        return renderNoAnswer();
    }
};

const AnswerContainer = styled.div`
    margin: 0 20px;
    padding: 20px;
    border-radius: 8px;
    background-color: #ffffff;
`;

const BlindedAnswerContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    ${({ theme }) => theme.flex.justifyCenter};
    margin: 0 20px;
    height: 160px;
    border-radius: 8px;
    background-color: #ffffff;
`;

const NoAnswerContainer = styled.div`
    padding-top: 52px;
`;

const AnswerCount = styled.h3`
    padding: 20px 0 12px 20px;
    ${FontStyle(12, 20, '400', '#ACACAC', -1)};
    margin: 0;
`;

const AnswerText = styled.div`
    word-wrap: break-word;
    ${FontStyle(15, 23, '400', '#444', -1)};
`;

const Divider = styled(DividerDefault)`
    margin-top: 17px;
    margin-bottom: 10px;
`;

export default RenderAnswer;
